export default {
  Pretitle: '404 Page not found',
  Title: 'What’s the ‘dillo?',
  Subtitle: 'The page you’re looking for isn’t available.',
};
